import { faGear } from '@fortawesome/free-solid-svg-icons';
import { faHeartbeat } from '@fortawesome/pro-solid-svg-icons';
import { headerNames } from './constants';

const parentPath = '/system';

export const systemRoutes = {
  system: {
    path: `${parentPath}`,
    key: 'system',
    value: headerNames?.system,
    icon: faGear,
    QADataTag: 'systemNav',
    permission: 'admin.dashboard.view',
  },
  health: {
    path: `${parentPath}/health`,
    key: 'health',
    value: 'Health/Settings',
    icon: faHeartbeat,
    QADataTag: 'healthNav',
    permission: 'admin.dashboard.view',
  },
};
